import { useState } from 'react';
import styled from 'styled-components';

// comps
import { Dialog, Typography } from '@mui/material';
import GlobalButton from '../global/button';
import DialogTemplate from './dialogTemplate';

import { colors } from '../../theme';

export interface DeleteDialogProps {
    buttonText?: string;
    onClose?: () => void;
    isWarning?: boolean;
    deleteItem?: string;
    onDelete?: () => void;
    isCancel?: boolean;
    warningText?: string;
}

const DeleteDialog = (props: any) => {
    const { buttonText, onClose, isWarning, deleteItem, onDelete, isCancel, warningText } = props;

    const renderContent = () => {
        return (
            <Container>
                <DialogText>
                    <Typography variant="h4">
                        Are you sure you want to {isCancel ? 'cancel' : 'delete'} {deleteItem}?
                    </Typography>
                    {warningText && <Typography sx={{ mb: '1em' }}>{warningText}</Typography>}
                    <Typography sx={{ color: isWarning && colors.red.main }}>{isWarning && 'This action cannot be undone.'}</Typography>
                </DialogText>
                <FooterContent>
                    <GlobalButton text="cancel" variant="outlined" onClick={onClose} />
                    <GlobalButton text={buttonText} onClick={onDelete} buttoncolor={colors.red} />
                </FooterContent>
            </Container>
        );
    };

    return (
        <>
            <DialogTemplate {...props} title={`${isCancel ? 'Cancel' : 'Delete'} ${deleteItem}`} titleColor={colors.red.main} renderContent={renderContent} />
        </>
    );
};

export default DeleteDialog;

const Container = styled.div`
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const DialogText = styled.div`
    text-align: center;
    padding: 20px;

    h4 {
        line-height: 1.5;
        font-weight: 500;
        padding-bottom: 10px;
    }
`;

const FooterContent = styled.div`
    padding-top: 15px;
    width: 100%;
    border-top: 1px solid ${colors.grey.light};
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
